"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const VerticalFormFieldInput_1 = require("./VerticalFormFieldInput");
const HorizontalFormFieldInput_1 = require("./HorizontalFormFieldInput");
const utils_1 = require("./../utils");
exports.InputText = (props) => {
    const { vertical } = props, otherProps = __rest(props, ["vertical"]);
    return renderFormFieldInput(props);
};
exports.InputText.displayName = 'FormField.InputText';
exports.InputText.defaultProps = Object.assign({}, utils_1.commonDefaultProps, {
    success: false,
    successMessage: '',
    type: 'text',
    valueIsArray: false,
    vertical: false,
    onChange: () => { return; },
});
const renderFormFieldInput = (props) => {
    const { vertical } = props, otherProps = __rest(props, ["vertical"]);
    if (vertical) {
        return React.createElement(VerticalFormFieldInput_1.VerticalFormFieldInput, Object.assign({}, otherProps));
    }
    else {
        return React.createElement(HorizontalFormFieldInput_1.HorizontalFormFieldInput, Object.assign({}, otherProps));
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/demo/examples/FormExample/InputText/InputText.tsx
// module id = 238
// module chunks = 0